// Polyfill for Object.hasOwn (needed for iOS 12 and older browsers)
if (!Object.hasOwn) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GlobalStyle from "./GlobalStyle";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import CombinedContextProviders from "./context/CombinedContextProviders";
import "./middleware/i18n";
import { createBrowserHistory } from "history";
import { HelmetProvider } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SEO from "./SEO";
import Tracking from "./Tracking";
import LdJson from "./LdJson";
import { initSentry } from "./utils/sentry";
import * as Sentry from "@sentry/react";

// Initialize Sentry for error tracking (must be called before React renders)
initSentry();

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

// NewRelic disabled - using Sentry for error tracking instead
// Original condition: if (process.env.NODE_ENV !== 'development')
if (false) {
  const script = document.createElement('script');
  script.src = `${process.env.PUBLIC_URL}/js/newRelic.js`; // Path to your script in public folder
  script.async = true;
  document.head.appendChild(script);
}

// Configure React root with Sentry error handlers
const root = ReactDOM.createRoot(document.getElementById("root"), {
  // Callback called when an error is thrown and not caught by an ErrorBoundary
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <>
    {/* <React.StrictMode> */}
    <CombinedContextProviders>
      <GlobalStyle />
      <HelmetProvider>
        <Router
          future={{
            v7_startTransition: false,
            v7_relativeSplatPath: true,
          }}
        >
          <App />
          <SEO />
          <Tracking />
          <LdJson />
        </Router>
      </HelmetProvider>
    </CombinedContextProviders>
    {/* </React.StrictMode> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
